import React from 'react'
import { X, AlertTriangle } from 'lucide-react'
import './styles.scss'

export default function DeleteModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Deletion", 
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  isDeleting = false
}) {
  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-content fade-in delete-modal" style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div className="warning-icon-wrapper">
              <AlertTriangle size={24} color="#dc2626" />
            </div>
            <h2 style={{ margin: 0, color: '#111827' }}>{title}</h2>
          </div>
          <button className="icon-btn" onClick={onClose} disabled={isDeleting}><X size={20} /></button>
        </div>
        
        <div className="modal-body" style={{ padding: '24px' }}>
          <p style={{ margin: 0, color: '#4b5563', lineHeight: '1.5' }}>
            {message}
          </p>
        </div>
        
        <div className="modal-footer" style={{ padding: '16px 24px', background: '#f9fafb', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
          <button 
            className="btn btn-outline" 
            onClick={onClose} 
            disabled={isDeleting}
          >
            {cancelText}
          </button>
          <button 
            className="btn" 
            style={{ background: '#dc2626', color: 'white', border: 'none' }} 
            onClick={onConfirm} 
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
